export const KEY_LOCALE = 'locale';
export const KEY_THEME = 'theme';

export { default as globalActions } from './actions';
